/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react'
import { view } from 'react-easy-state'
// import OtpInput from 'react-otp-input'
import OtpInput from '../../components/generics/OtpInput'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Button from '../../components/generics/Button'
import otpStore from '../../core/stores/Viriyah/otpStore'
import tokenStore from '../../core/stores/Viriyah/tokenStore'
import infoStore from '../../core/stores/Viriyah/infoStore'
import userStore from '../../core/stores/Viriyah/userStore'

import * as validate from '../../core/utils/Validate'
import { mappingMessageCode } from '../../core/utils/Utils'

let firstTimeUse = false

interface otpForm {
  errorMessage: validate.ErrorStatus
  otpRenewable: boolean
}
interface otpCount {
  minute: string
  second: string
}

export default view(() => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [otpKey, setOtpKey] = React.useState(Date.now())
  const [otpCount, setOtpCount] = React.useState<otpCount>({
    minute: '',
    second: ''
  })
  const [otpForm, setOtpForm] = React.useState<otpForm>({
    errorMessage: { message: '', status: false },
    otpRenewable: false
  })

  const renewOtpCount = () => {
    const countDownTime = Date.now() + (60000 * 3) //change OTP countdown to 3 minutes
    const session = window.setInterval(() => {
      const now = Date.now()
      const distance = countDownTime - now
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)

      const minutesStr = minutes.toString()
      let secondsStr = seconds.toString()

      if (seconds < 10) {
        secondsStr = '0' + seconds.toString()
      }

      setOtpCount({ minute: minutesStr, second: secondsStr })
      if (distance < 1000) {
        clearInterval(session)
        setOtpForm({ errorMessage: otpForm.errorMessage, otpRenewable: true })
      }
    }, 1000)
  }

  React.useEffect(() => {
    if (!firstTimeUse) {
      renewOtpCount()
      firstTimeUse = true
    }
  })

  const handleOtp = (e: any) => {
    otpStore.setOtp(e)
    setOtpForm({
      ...otpForm,
      errorMessage: { message: '', status: false }
    })
    if (otpStore.checkCompleteOtp()) {
      clickConfirmOtp()
    }
  }

  const checkOtpInput = (): boolean => {
    return !otpStore.checkCompleteOtp()
  }

  const requestNewOtp = () => {
    const pathName = 'generateOTP'
    const payload = {
      mobileNumber: infoStore.mobileNumber,
      userId: userStore.userId
    }
    setOtpForm({
      ...otpForm,
      errorMessage: { message: '', status: false }
    })
    window.bizlink
      .trigger('POST', {
        payload,
        pathName
      })
      .then((response: any) => {
        console.log('requestNewOtp! response.requestId : ' + response.requestId)
        if (response.message == 'successfully') {
          const referenceCode: string = response.requestId || ''
          tokenStore.setReOtp(referenceCode)
          console.log('tokenStore.referenceCode : ' + tokenStore.referenceCode)
          otpStore.setOtp('')

          setOtpForm({
            errorMessage: { message: '', status: false },
            otpRenewable: false
          })

          otpStore.setOtp('')
          setOtpKey(Date.now())
          renewOtpCount()
        } else {
          console.log('requestNewOtp not success!!!', response)
          const errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 50, response?.status)
          otpStore.setOtp('')
          setOtpKey(Date.now())
          setOtpForm({
            ...otpForm,
            errorMessage: { message: errorMessage, status: true }
          })
        }
      })
      .catch(err => {
        console.log(err)
        const errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 50, err.response?.status)
        setOtpForm({
          ...otpForm,
          errorMessage: { message: errorMessage, status: true }
        })
      })
  }

  const clickConfirmOtp = () => {
    const pathName = 'verifyOTP'
    const payload = {
      pin: otpStore.otp,
      requestId: tokenStore.referenceCode,
      userId: userStore.userId
    }

    window.bizlink
      .trigger('POST', {
        payload,
        pathName
      })
      .then((response: any) => {
        console.log('response.active : ' + response.active)

        if (response.active) {
          console.log('updateStatus')
          updateStatus()
        } else {
          console.log('verifyOTP not success!!!', response)

          const errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 60, response?.status)
          otpStore.setOtp('')
          setOtpKey(Date.now())
          setOtpForm({
            ...otpForm,
            errorMessage: { message: errorMessage, status: true }
          })
        }
      })
      .catch(err => {
        console.log('error', pathName, 'with', err.message)

        let errorMessage = ''
        if (err.message.includes('status code 400')) {
          errorMessage = mappingMessageCode(t('viriyah.validate-message.otp-alert.repeat-otp'), 60, 400)
        } else {
          errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 60, err.response?.status)
        }

        setOtpForm({
          ...otpForm,
          errorMessage: { message: errorMessage, status: true }
        })
        otpStore.setOtp('')
        setOtpKey(Date.now())
      })
  }

  const updateStatus = () => {
    const pathName = 'updateStatus'
    const payload = {
      success: true,
      userId: userStore.userId
    }
    window.bizlink
      .trigger('POST', {
        payload,
        pathName
      })
      .then((response: any) => {
        console.log('updateStatus response : ' + response)

        if (response == 'success') {
          navigate('/login-success', { replace: true })
        } else {
          console.log('updateStatus not success!!!')
          const errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 70, response?.status)
          setOtpForm({
            ...otpForm,
            errorMessage: { message: errorMessage, status: true }
          })
        }
      })
      .catch(err => {
        console.log(err)
        const errorMessage = mappingMessageCode(t('viriyah.validate-message.service-error'), 70, err.response?.status)
        setOtpForm({
          ...otpForm,
          errorMessage: { message: errorMessage, status: true }
        })
      })
  }

  return (
    <>
      <section className="request-otp-form pt-16">
        <div className="container">
          <h6 className="" id="otp-title">
            {t('viriyah.otp-page.title')}
          </h6>
          <div className="form-group mb-5">
            <h6 className="form-title-style mb-5">
              {t('viriyah.otp-page.description_1')} <br />
              {t('viriyah.otp-page.description_2')} {infoStore.mobileNumber} <br />
              {t('viriyah.otp-page.description_3')} {tokenStore.referenceCode} )
            </h6>

            {otpForm.errorMessage.status ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: otpForm.errorMessage.status
                    ? t('viriyah.otp-page.logo') +
                      "<div style='width: 90%; padding-left: 2%;'><p>" +
                      t(otpForm.errorMessage.message) +
                      '</p></div></div>'
                    : ''
                }}
              />
            ) : null}

            <div className="otp-input-box mb-3 mt-5">
              <OtpInput
                inputStyle={{
                  border: '2px solid #E5E5E5',
                  width: 40,
                  height: 50,
                  margin: '3px',
                  borderRadius: 10,
                  fontSize: '20px',
                  fontweight: 'bold'
                }}
                focusStyle={{
                  border: '2px solid #E5E5E5',
                  width: 40,
                  height: 50,
                  margin: '3px',
                  borderRadius: 10,
                  fontSize: '20px',
                  outline: 'none',
                  fontweight: 'bold'
                }}
                onChange={handleOtp}
                value={otpStore.otp}
                numInputs={6}
                separator={<span></span>}
                shouldAutoFocus={true}
                key={otpKey}
                isInputNum={true}
              />
            </div>
          </div>
        </div>

        <div className="bottom-section w-100">
          <div className="button-confirm">
            <Button
              id="button-style"
              isDisable={checkOtpInput()}
              customBgColor="#0033A2"
              optionalClass="w-100 py-3"
              textColor="white"
              onClick={clickConfirmOtp}
            >
              {t('viriyah.otp-page.button-confirm')}
            </Button>
          </div>
          <div>
            <Button
              id="button-otp-again-style"
              isDisable={!otpForm.otpRenewable}
              customBgColor="#EDEDED"
              optionalClass="w-100 py-3"
              textColor="black"
              onClick={requestNewOtp}
            >
              {otpForm.otpRenewable
                ? t('viriyah.otp-page.button-renew')
                : t('viriyah.otp-page.button-renew') + ' (' + otpCount.minute + ':' + otpCount.second + ' นาที)'}
            </Button>
          </div>
        </div>
      </section>
    </>
  )
})
